<!--  -->
<template>
  <div class="course-sku">
    <van-popup v-model="show" position="bottom" :style="{ height: '75%' }" duration="0.18" round>
      <section class="section">
        <h1 class="course-title">
          <span>请选择课程</span><van-icon @click="show = false" name="cross" />
          <p>请如实填写购买课程的信息，信息确认无误后，将在1-2天内开课</p>
        </h1>
        <div class="course-box" v-if="show">
          <CourseSku
            v-for="(item, index) in productList"
            :key="index"
            :courseInfo="item"
            @triggerChecked="receiveCourse"
          />
        </div>
        <div class="foot">
          <div @click="toBuy">确认</div>
        </div>
      </section>
    </van-popup>
  </div>
</template>

<script>
import { resCourseTmall } from '@/api/personal/courseTmall';
import CourseSku from './courseSku.vue';

export default {
  components: {
    CourseSku,
  },
  data() {
    return {
      show: false,
    };
  },
  props: {
    productList: {
      type: Array,
      default: () => [],
    },
  },
  computed: {},
  watch: {},
  methods: {
    async toBuy() {
      const chooseProductList = this.productList.filter((product) => product.selected);
      if (!chooseProductList.length) {
        this.$toast('请选择课程');
        return;
      }
      this.$emit('chooseProductList', chooseProductList);
    },
    receiveCourse(course) {
      const { setId, productSkuId, selected } = course;
      // console.log(course, 'course');

      this.productList.forEach((item) => {
        if (item.setId === setId) {
          Object.assign(item, { productSkuId, selected });
        }
      });
    },
  },
  created() {},
  mounted() {},
};
</script>
<style lang="scss" scoped>
.course-sku {
  ::v-deep .van-popup--bottom.van-popup--round {
    border-radius: 27px 27px 0 0 !important;
  }
}

.course-title {
  position: fixed;
  z-index: 100;
  width: 100%;
  padding: 40px 0 36px 0;
  color: #333;
  font-weight: 500;
  font-size: 33px;
  line-height: 45px;
  text-align: center;
  background: #f9f9f9;
  border-radius: 54px 54px 0 0;
  ::v-deep .van-icon {
    position: absolute;
    top: 23px;
    right: 18px;
    color: #333;
    font-size: 18px;
  }
  p {
    padding-top: 18px;
    color: #ff3938;
    font-weight: 400;
    font-size: 22px;
    line-height: 31px;
    text-align: center;
  }
}
.course-box {
  padding: 180px 0 170px 0;
}
.foot {
   position: fixed;
    bottom: 0;
    left: 0;
  width: 100%;
  height: 167px;
  background: #fff;
  box-shadow: 0 -4 14px 0 rgba(0, 0, 0, 0.05);
  div {
    width: 678px;
    height: 80px;
    margin: 22px auto 0;
    color: #fff;
    font-weight: 500;
    font-size: 29px;
    line-height: 80px;
    text-align: center;
    background: #ff7f41;
    border-radius: 49px;
  }
}
</style>
